import React from 'react';
import { useTermsAcceptance } from '@/features/auth/hooks';
import { TermsModal } from './TermsModal';

interface TermsGateProps {
  children: React.ReactNode;
}

/**
 * Componente gate que exibe o modal de Termos de Uso quando o usuário
 * ainda não aceitou a versão atual. Renderiza os children normalmente
 * se já aceitou ou enquanto verifica.
 *
 * Deve envolver o conteúdo protegido (layouts, dashboards).
 */
export const TermsGate: React.FC<TermsGateProps> = ({ children }) => {
  const { needsAcceptance, accepting, acceptTerms, checking, currentDocument } = useTermsAcceptance();

  // Enquanto verifica, renderiza normalmente (evita flash)
  if (checking) {
    return <>{children}</>;
  }

  return (
    <>
      {children}
      <TermsModal
        open={needsAcceptance}
        accepting={accepting}
        onAccept={acceptTerms}
        currentDocument={currentDocument}
      />
    </>
  );
};
